import { keepPreviousData } from '@tanstack/react-query';
import { useGetFinanceDashboard } from '@/api/generated/finance/finance';
import { selectData } from '@/api/envelope';
import type { FinanceDashboardResponseDTO } from '@/api/generated/model';
import type { TimeRangeBounds } from '@/lib/timeRangeOptions';

export type { FinanceDashboardResponseDTO };

export function useFinanceDashboard(
  range: TimeRangeBounds | number | null | undefined,
  currency = 'AUD',
  countryCode?: string,
) {
  const bounds: TimeRangeBounds =
    range == null || typeof range === 'number'
      ? range == null
        ? {}
        : { days: range }
      : range;

  return useGetFinanceDashboard(
    {
      ...(bounds.days != null ? { days: bounds.days } : {}),
      ...(bounds.startDate ? { startDate: bounds.startDate } : {}),
      ...(bounds.endDate ? { endDate: bounds.endDate } : {}),
      currency,
      ...(countryCode ? { countryCode } : {}),
    },
    {
      query: {
        select: selectData,
        placeholderData: keepPreviousData,
      },
    },
  );
}
